module.exports = __webpack_public_path__ + "static/media/oneMilion.1e540c0d.ogg";